export default __webpack_public_path__ + "static/media/abraham_peled.45a12db4.jpeg";